import { Skeleton } from '@mui/material'
import styled from '@emotion/styled'
import { maxWidth, space } from '../../styles/size'

interface Props {
   className?: string
}

const SkeletonForm: React.FC<Props> = ({ className }) => {
   return (
      <Holder className={className}>
         <Skeleton variant="rectangular" className="skeleton-form-field" />
         <Skeleton variant="rectangular" className="skeleton-form-field" />
         <span className="skeleton-form-line" />
         <Skeleton variant="rectangular" className="skeleton-form-field" />
         <Skeleton variant="rectangular" className="skeleton-form-button" />
      </Holder>
   )
}

const Holder = styled.div`
   display: flex;
   flex-direction: column;
   background-color: #fff;
   width: 100%;
   gap: 1.3em;
   max-width: ${maxWidth.onboardingForm};

   .skeleton-form-title {
      height: 3.2em;
      width: 50%;
      border-radius: ${space.m};
      overflow: hidden;
      align-self: center;
   }

   .skeleton-form-field {
      height: 3.2em;
      width: 100%;
      border-radius: ${space.xs};
      overflow: hidden;
   }

   .skeleton-form-button {
      height: 3.5em;
      width: 50%;
      border-radius: 50em;
      overflow: hidden;
      margin-top: 0.7em;
      align-self: flex-end;
   }

   .skeleton-form-line {
      height: 1px;
      width: 100%;
      background-color: #e0e0e0;
   }
`

export default SkeletonForm
